const getEnvironment = (): "development" | "staging" | "production" => {
  if (window.location.origin.includes("localhost")) {
    return "development";
  }

  if (window.location.origin.includes("staging")) {
    return "staging";
  }

  return "production";
};

export { getEnvironment };
